'use client';
import { isString } from '@s7/utils';
import { createDarkener } from '../darken/darken.js';
import { createLightener } from '../lighten/lighten.js';
import { isConvertibleColor } from '../../../modules/colors/impl/validators/validators.js';
import { toRGBA } from '../../../modules/colors/impl/toRGBA/toRGBA.js';

const applyTransform = (rgba, transform)=>{
    const { r, g, b, a } = rgba;
    return `rgba(${transform(r)}, ${transform(g)}, ${transform(b)}, ${a})`;
};
const fallback = {
    max: '#000',
    big: '#000',
    base: '#000',
    mid: '#000',
    min: '#000'
};
const deriveShades = (theme)=>(raw)=>{
        if (isString(raw)) {
            if (!isConvertibleColor(raw)) {
                return fallback;
            }
            const rgba = toRGBA(raw);
            const isDay = theme.mode === 'day';
            const multiplier = isDay ? 1 : 1.25;
            return {
                max: applyTransform(rgba, createDarkener(0.3 * multiplier)),
                big: applyTransform(rgba, createDarkener(0.2 * multiplier)),
                base: isDay ? raw : applyTransform(rgba, createDarkener(0.1)),
                mid: applyTransform(rgba, createLightener(0.4)),
                min: applyTransform(rgba, createLightener(0.55))
            };
        }
        return raw;
    };

export { deriveShades };
//# sourceMappingURL=deriveShades.js.map
